import { Accordion, AccordionDetail, AccordionHeader, AccordionItem, AccordionTitle } from "@vds/accordions";
import { DatePicker } from "@vds/date-pickers";
import { Icon } from "@vds/icons";
import { DropdownSelect } from "@vds/selects";
import moment from "moment";
import {
  DATE_FORMAT_MMDDYYYY,
  datepickerListitems,
  END_OF_DAY,
  MIN_DATE,
  MS_ONE_DAY,
  MS_SEVEN_DAYS,
  MS_SIX_DAYS,
  MS_SIX_MONTHS,
  MS_THIRTY_DAYS,
  TIME_ZERO
} from "../../../../global/constants/statistics.dateConstants";
import { useStatisticContext } from "../../contexts/StatisticContext";
import { STATISTICS_TEST_IDS } from "../../statisticsConstants";

const DateSelection = () => {
  const {
    activeDateAccordion,
    setActiveDateAccordion,
    activeDatepickerListIndex,
    setActiveDatepickerListIndex,
    setDateTimeToggleDropdown,
    endDateTime,
    setEndDateTime,
    endInputDate,
    setEndInputDate,
    setStartDateTime,
    setStartInputDate,
    startDateTime,
    startInputDate
  } = useStatisticContext();

  const toggleDateAccordion = (index) => {
    setActiveDateAccordion(activeDateAccordion === index ? null : index);
  };

  // Internal date handling functions (moved from parent component)
  const getFormattedDate = (timeStamp) => {
    if (timeStamp) {
      return moment(timeStamp).format(DATE_FORMAT_MMDDYYYY);
    }
    return "";
  };

  const handleStartDateChange = (startDate) => {
    let selecteStartInputdate = moment(new Date(startDate).setHours(...TIME_ZERO)).toISOString();
    setStartInputDate(selecteStartInputdate);
    setEndInputDate("");
    setStartDateTime(selecteStartInputdate);
  };

  const handleEndDateChange = (endDate) => {
    const currentdate = moment(new Date(Date.now()).setHours(...TIME_ZERO));
    const selectedEndDate = moment(new Date(new Date(endDate).setHours(...TIME_ZERO)));
    let selecteEndInputdate = new Date(new Date(endDate).setHours(new Date(Date.now()).getHours(), new Date(Date.now()).getMinutes(), 0, 0)).toISOString();
    if (currentdate.diff(selectedEndDate) != 0) {
      selecteEndInputdate = new Date(new Date(endDate).setHours(...END_OF_DAY)).toISOString();
    } else {
      selecteEndInputdate = new Date(new Date(endDate).setHours(new Date(Date.now()).getHours(), new Date(Date.now()).getMinutes(), 0, 0)).toISOString();
    }
    setEndInputDate(selecteEndInputdate);
    setEndDateTime(selecteEndInputdate);
  };

  const handleDatepickerItemSelection = (index) => {
    switch (index) {
      case 1:
        // setFilterList({ ...filterlist, Day: 'Custom'});
        break;
      case 2:
        setStartInputDate(moment(new Date(Date.now()).setHours(...TIME_ZERO)).toISOString());
        setStartDateTime(moment(new Date(Date.now()).setHours(...TIME_ZERO)).toISOString());
        setEndInputDate(moment(new Date(Date.now())).toISOString());
        setEndDateTime(moment(new Date(Date.now())).toISOString());
        break;
      case 3:
        setStartInputDate(moment(new Date(Date.now() - MS_ONE_DAY).setHours(...TIME_ZERO)).toISOString());
        // setFilterList({ ...filterlist, Day: datepickerListitems[index -2].text });
        setStartDateTime(moment(new Date(Date.now() - MS_ONE_DAY).setHours(...TIME_ZERO)).toISOString());
        setEndInputDate(moment(new Date(Date.now() - MS_ONE_DAY).setHours(...END_OF_DAY)).toISOString());
        setEndDateTime(moment(new Date(Date.now() - MS_ONE_DAY).setHours(...END_OF_DAY)).toISOString());
        break;
      case 4:
        setStartInputDate(moment(new Date(Date.now() - MS_SEVEN_DAYS).setHours(...TIME_ZERO)).toISOString());
        setStartDateTime(moment(new Date(Date.now() - MS_SEVEN_DAYS).setHours(...TIME_ZERO)).toISOString());
        setEndInputDate(moment(new Date(Date.now())).toISOString());
        setEndDateTime(moment(new Date(Date.now())).toISOString());
        break;
      case 5:
        setStartInputDate(moment(new Date(Date.now() - MS_THIRTY_DAYS).setHours(...TIME_ZERO)).toISOString());
        setStartDateTime(moment(new Date(Date.now() - MS_THIRTY_DAYS).setHours(...TIME_ZERO)).toISOString());
        setEndInputDate(moment(new Date(Date.now())).toISOString());
        setEndDateTime(moment(new Date(Date.now())).toISOString());
        break;
      case 6:
        setStartInputDate(moment(new Date(Date.now() - MS_SIX_MONTHS).setHours(...TIME_ZERO)).toISOString());
        setStartDateTime(moment(new Date(Date.now() - MS_SIX_MONTHS).setHours(...TIME_ZERO)).toISOString());
        setEndInputDate(new Date(Date.now()).toISOString());
        setEndDateTime(new Date(Date.now()).toISOString());
        break;
      case 7:
        const getCurrentYear = new Date().getFullYear();
        const calculatedStartDate = new Date().setFullYear(getCurrentYear, 0, 1);
        setStartInputDate(moment(new Date(calculatedStartDate).setHours(...TIME_ZERO)).toISOString());
        setStartDateTime(moment(new Date(calculatedStartDate).setHours(...TIME_ZERO)).toISOString());
        setEndInputDate(new Date(Date.now()).toISOString());
        setEndDateTime(new Date(Date.now()).toISOString());
        break;
      case 8:
        const getPreviousYear = new Date().getFullYear() - 1;
        const getPreviousYearMonth = new Date().getMonth();
        const getPreviousYearDay = new Date().getDate();
        const calculatedPrevYearStartDate = new Date().setFullYear(getPreviousYear, getPreviousYearMonth, getPreviousYearDay);
        setStartInputDate(moment(new Date(calculatedPrevYearStartDate).setHours(...TIME_ZERO)).toISOString());
        setStartDateTime(moment(new Date(calculatedPrevYearStartDate).setHours(...TIME_ZERO)).toISOString());
         setEndInputDate(new Date(Date.now()).toISOString());
        setEndDateTime(new Date(Date.now()).toISOString());
        break;
      default:
        setStartInputDate("");
        setEndInputDate("");
        setStartDateTime(moment(new Date(Date.now() - MS_SIX_DAYS).setHours(...TIME_ZERO)).toISOString());
         setEndInputDate(new Date(Date.now()).toISOString());
        setEndDateTime(new Date(Date.now()).toISOString());
    }
   
  };

  return (
    <>
      <div className="filterTowerItemSeparator"></div>
      <div className="filterTowerItems">
        <div className="statisticsAccordion">
          <Accordion>
            <AccordionItem opened={activeDateAccordion === 2} style={{ fontSize: "16px", width: "90%" }}>
              <AccordionHeader
                triggerType="icon"
                style={{ top: "8px" }}
                data-testid={STATISTICS_TEST_IDS.ACCORDION_HEADER_DATE}
                onClick={() => toggleDateAccordion(2)}
              >
                <AccordionTitle>
                  <div className="flexColumn">
                    <div className="flexRow">
                      <span style={{ paddingRight: "10px" }}>
                        <Icon name="calendar" />
                      </span>
                      <p
                        style={{
                          fontWeight: "100",
                          margin: "0",
                          lineHeight: "27px"
                        }}
                        size="small"
                      >
                        Date
                      </p>
                    </div>
                    {activeDateAccordion !== 2 && (
                      <div className="filterSelectedVal">
                        Selected :{" "}
                        <span>
                          {" "}
                          {/* {moment(startDateTime).format(DATE_FORMAT_MMM_DD_YYYY)} - {moment(endDateTime).format(DATE_FORMAT_MMM_DD_YYYY)}{" "} */}
                          {activeDatepickerListIndex === 2 && moment(startInputDate).format("MM/DD/YY") === moment(endInputDate).format("MM/DD/YY")
                            ? moment(startInputDate).format("MM/DD/YY")
                            : `${moment(startInputDate).format("MM/DD/YY")} - ${moment(endInputDate).format("MM/DD/YY")}`}
                        </span>
                      </div>
                    )}
                  </div>
                </AccordionTitle>
              </AccordionHeader>
              <AccordionDetail>
                <div className="dateWrapper">
                  <DropdownSelect
                    style={{ fontSize: "16px", width: "100%" }}
                    label="Date range"
                    value={activeDatepickerListIndex}
                    onChange={(e) => {
                      const index = Number(e.target.value);
                      setActiveDatepickerListIndex(index);
                      handleDatepickerItemSelection(index);
                    }}
                  >
                    {datepickerListitems.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.text}
                      </option>
                    ))}
                  </DropdownSelect>
                  {activeDatepickerListIndex && activeDatepickerListIndex !== 1 && (
                    <div className="selectedDateRange">
                      Selected:
                      <span>
                        {activeDatepickerListIndex === 2 && moment(startInputDate).format("MM/DD/YY") === moment(endInputDate).format("MM/DD/YY")
                          ? moment(startInputDate).format("MM/DD/YY")
                          : `${moment(startInputDate).format("MM/DD/YY")} - ${moment(endInputDate).format("MM/DD/YY")}`}
                      </span>
                    </div>
                  )}
                </div>
                {activeDatepickerListIndex === 1 && (
                  <div className="dateTimeDropdownWrapper" style={{ marginTop: "10px" }}>
                    <DatePicker
                      dateFormat={DATE_FORMAT_MMDDYYYY}
                      id="from"
                      data-testid={STATISTICS_TEST_IDS.DATEPICKER_FROM_INPUT}
                      alwaysOpen={false}
                      surface="light"
                      minDate={MIN_DATE}
                      label="Start date"
                      onChange={handleStartDateChange}
                      value={getFormattedDate(startInputDate)}
                      maxDate={endInputDate ? new Date(endInputDate) : new Date()}
                    />
                    <DatePicker
                      dateFormat={DATE_FORMAT_MMDDYYYY}
                      id="to"
                      data-testid={STATISTICS_TEST_IDS.DATEPICKER_TO_INPUT}
                      alwaysOpen={false}
                      errorText=" "
                      surface="light"
                      minDate={startInputDate ? new Date(startInputDate) : MIN_DATE}
                      maxDate={new Date()}
                      label="End date"
                      onChange={handleEndDateChange}
                      value={getFormattedDate(endInputDate)}
                      helperText={endInputDate.length === 0 ? "Please select end date." : ""}
                      helperTextPlacement="bottom"
                    />
                  </div>
                )}
              </AccordionDetail>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default DateSelection;
